import { createSelector } from 'reselect'
import userDataSelector from 'redux/selectors/user/user_data_selector'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import productTypes from 'helpers/enums/productTypes'


const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.GOOGLE_SLIDES_SILVER_PAYWALL,
])

const googleSlidesUnauthorizedUserSelector = createSelector(
	[userDataSelector, featureFlagsSelector],
	(userData, featureFlags) => {

		const shouldBlockSilverUsers = featureFlags[featureFlagsTypes.GOOGLE_SLIDES_SILVER_PAYWALL]

		const isSilverUser = userData.productId === productTypes.SILVER

		return shouldBlockSilverUsers && isSilverUser
	}
)

export default googleSlidesUnauthorizedUserSelector
